jQuery(document).ready(function($) {

  //---------------------------------------------------------
// DEV TOOLS - GRIGLIA RESPONSIVE

$('#rw-dev-grid').on('click', function(e) {
  $(this).fadeOut();
});

//---------------------------------------------------------
// Scroll to #div

  	var spazio = 0;
  	if ($('body').hasClass('admin-bar')) {
  		var spazio = 32;
  	}
  	$('a[href^="#"]:not(.modale, .us_box, .btn.tab, .btn-acc, #master-carousel .item)').on('click', function(e) {
  		e.preventDefault();
  		var target = this.hash,
  			$target = $(target);
  		$('html, body').stop().animate({
  			scrollTop: ($target.offset().top - spazio)
  		}, 900, 'swing');
  	});

  	$(window).scroll( function(){
      $('.slide-top').each( function(i){
          var bottom_of_object = $(this).position().top + $(this).outerHeight();
          var bottom_of_window = $(window).scrollTop() + $(window).height();

          /* Adjust the "200" to either have a delay or that the content starts fading a bit before you reach it  */
          bottom_of_window = bottom_of_window + 100;

          if( bottom_of_window > bottom_of_object ){
              $(this).animate({'opacity':'1'},1000);
          }
      });
    });

    //---------------------------------------------------------
    // MENU ORIZZONTALE

    // non mi ricordo a cosa serviva questa:
    // ---------------------------------------
    // Abilita dropdown del menu al passaggio del mouse
    // var navbarToggle = '.navbar-toggler'; // name of navbar toggle, BS3 = '.navbar-toggle', BS4 = '.navbar-toggler'
    // $('.dropdown, .dropup').each(function() {
    //   var dropdown = $(this),
    //       dropdownToggle = $('[data-toggle="dropdown"]', dropdown),
    //       dropdownHoverAll = dropdownToggle.data('dropdown-hover-all') || false;
    //
    //   // Mouseover
    //   dropdown.hover(function(){
    //     var notMobileMenu = $(navbarToggle).size() > 0 && $(navbarToggle).css('display') === 'none';
    //     if ((dropdownHoverAll == true || (dropdownHoverAll == false && notMobileMenu))) {
    //       dropdownToggle.trigger('click');
    //     }
    //   })
    //
    // });

    // SUBMENU APERTO SE PAGINA ATTIVA
    $('ul.dropdown-menu li.active').closest('.dropdown-menu').toggleClass('show');

    function rwMenu() {
      $('nav .dropdown').each( function(){

        // salvo l'oggetto attuale x poterlo usare nella funzione subMenuFit
        submenu = this;

        function subMenuFit() {
          // Gestione submenu che escono dal container
          // viene attaccato a dx sottraendo la sua larghezza a quella della finestra
          var LarghezzaFinestra = $(window).width();
          var MenuOffset = $(submenu).offset();
          var MenuOffsetLeft = MenuOffset.left;

          LarghezzaSubmenu = 0;
          $('ul.dropdown-menu > li', submenu).each( function(){
            LarghezzaSubmenu = $(this).outerWidth() + LarghezzaSubmenu;
          });

          if((MenuOffsetLeft + LarghezzaSubmenu) > LarghezzaFinestra){
            $('ul.dropdown-menu', submenu).offset({ left: LarghezzaFinestra - LarghezzaSubmenu -15 });
          }
        }

        $(this).hover(function(){
          $('.dropdown-menu').removeClass('show');
          $('.dropdown-menu', this).toggleClass('show');
          subMenuFit();
        });

        $(this).mouseleave(function(){
          $('.dropdown-menu:not(.cliccato)').removeClass('show');
          $('ul.dropdown-menu:not(.cliccato) li.active').closest('.dropdown-menu').toggleClass('show');
        });

        subMenuFit();

        // $(this).click(function(){
        //   $('.dropdown-menu').removeClass('show');
        //   $('.dropdown-menu', this).toggleClass('show').addClass('cliccato');
        // });
      });
    }

    rwMenu();



      //---------------------------------------------------------
    // tooltip paletta colore

    var changeTooltipPosition = function(event) {
      var tooltipX = event.pageX;
      var tooltipY = event.pageY;
      $('div.picker_tooltip').css({top: tooltipY, left: tooltipX});
    };	/* gestisce lo spostamento del tooltip */

    var showpickerTooltip = function() {
      $('div.picker_tooltip').remove();

      $('<div class="picker_tooltip"><div class="tt-image"></div><div class="nome"></div><div class="desc small"></div></div>').appendTo('body');
      $("div.picker_tooltip .nome").append($(this).attr('data-nome'));
      $("div.picker_tooltip .desc").append($(this).attr('data-desc'));
      $("div.picker_tooltip .tt-image").css('background-color', $(this).attr('data-bck'));

      $(this).find('img.immagine').clone().appendTo("div.picker_tooltip .tt-image")
      $("div.picker_tooltip .tt-image img").addClass('img-contain');

      changeTooltipPosition();

    };	/* visualizza il tooltip con id dell'elemento svg g:hover*/

    var hidepickerTooltip = function() {
      $('div.picker_tooltip').remove();
    };	/* rimuove il tooltip */

    $(".rw-tooltip").bind({
      mousemove : changeTooltipPosition,
      mouseenter : showpickerTooltip,
      mouseleave: hidepickerTooltip
    });

    //---------------------------------------------------------
  // OWL CAROUSELS

  $('.slider-single').owlCarousel({
    loop:true,
    margin:30,
    nav:true,
    lazyLoad: true,
    onResized : rwOwlNav,
    onLoadedLazy : rwOwlNav,
    autoHeight: true,
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:true,
    navText: ["<img src='/content/themes/plust/dist/images/prev.svg'>","<img src='/content/themes/plust/dist/images/next.svg'>"],
      responsive:{
          0:{     // xs
              items:1
          },
          576:{   // sm
              items:1
          },
          768:{   // md
              items:1
          },
          992:{   // lg
              items:1
          },
          1200:{   // xl
              items:1
          }
      }
  })


  // PRODOTTI CORRELATI / FAMIGLIE
  $('.product-fam-rel').owlCarousel({
    loop:false,
    margin:30,
    nav:true,
    lazyLoad: true,
    onResize : rwOwlNav,
    onLoadedLazy : rwOwlNav,
    autoHeight: true,
    navText: ["<img src='/content/themes/plust/dist/images/prev.svg'>","<img src='/content/themes/plust/dist/images/next.svg'>"],
      responsive:{
          0:{     // xs
              items:1
          },
          576:{   // sm
              items:2
          },
          768:{   // md
              items:3
          },
          992:{   // lg
              items:4
          },
          1200:{   // xl
              items:4
          }
      }
  })


  // $('.owl-nav button').each( function(i){

  function rwOwlNav(event) {
    $('.owl-carousel').each( function(){
      var imgHeight = $('.owl-stage .owl-item:first-child img', this).height();
      // var itemHeight = $('.owl-stage .owl-item:first-child', this).height();
      $('.owl-nav button', this).height(imgHeight).fadeIn();
      // $('.owl-stage-outer', this).height(itemHeight).fadeIn();
    });
  }


  // switch tra family e related in scheda prodotto
  $('.pro-switch img').on('click', function( e ) {
    e.preventDefault();

    $('.owl-nav button').hide();

    var target = $(this).attr('data-target');
    var puls = $(this).attr('data-switch');

    $('.rw-carousel').toggleClass('active');
    $('.pro-switch img').toggleClass('active');

    setTimeout(rwOwlNav, 500);

  });

    //---------------------------------------------------------
  // DESIGNERS

  function designer(){
    if ($(window).width() > 576) { // > xs
      var Img_2_Top = $("#des-img-2").data('margin');
      $("#des-img-2").css("margin-top", Img_2_Top + "px");

      var bloccoImgHeight = $('#blocco-immagini').outerHeight(true);
      var Img_1_Height = $("#des-img-1").height();
      $("#blocco-citazione").css("margin-top", - ( bloccoImgHeight - Img_1_Height +80 ) );
    } else { // se xs azzero i margini
      $("#des-img-2").css("margin-top", "0");
      $("#blocco-citazione").css("margin-top", "0" );
    }
  }
  setTimeout(designer, 300);

    //---------------------------------------------------------
  // MYPLUST

  // Filtri downloads
  // Vedi rw-isotope-init.js

  // Uncheck degli input del prodotto precedente quando si clicca sulle checkbox di un nuovo prodotto
  $('.dropdown-menu.myplust').find('form').click(function (e) {
    e.stopPropagation();

    var questo = $(this).attr('id');
    var attivo = localStorage['idFormProdotto'];
    if( attivo !== questo ){
      localStorage['idFormProdotto'] = questo;
      $('#' + attivo ).find('input').prop('checked', false);
    }
  });

  // Check di tutti gli input
  $(".checkAll").click(function() {
    $(this).closest('form').find('input').prop('checked', $(this).prop('checked'));
  });

  // tooltip sull'icona apri file
  $('a.visualizza[data-toggle="tooltip"]').tooltip();

  // Creo un array JSON con tutti gli input selezionati
  function ConvertFormToJSON(form){
    var array = jQuery(form).serializeArray();
    var json = {};
    jQuery.each(array, function() {
      json[this.name] = this.value || '';
    });
    return json;
  }

  // Al submit invio l'array JSON via ajax
  $('form.single-product-form').bind('submit', function(event){
    event.preventDefault();

    var form = this;
    var prodotto = $(this).attr('data-name');
    var json = ConvertFormToJSON(form);
    var lang = $('html').attr('lang');

    $.ajax({
      type: "POST",
      url: "/content/themes/plust/lib/downloadzip.php",
      data: {json: json, prodotto: prodotto},
      dataType: "json"
    }).always(function() {
      // console.log(json);
      // console.log(prodotto);
      $('#myplust-modal').modal();

    }).fail(function() {
      $.ajax({
        type: 'GET',
        url: '/content/themes/plust/templates/components/myplust-fail.php',
        dataType: 'html',
        data: {
          lang: lang
        },
        success: function(html){
          $('#myplust-modal .modal-body').html(html);
        }
      });
    }).success(function(msg){
      // console.log(msg.success);
      if(msg.success = true){
        $.ajax({
          type: 'GET',
          url: '/content/themes/plust/templates/components/myplust-success.php',
          dataType: 'html',
          data: {
            lang: lang
          },
          success: function(html){
            $('#myplust-modal .modal-body').html(html);
            $('#myplust-modal .modal-body a.download-link').attr('href', msg.percorso);
          }
        });

      } else {

        $.ajax({
          type: 'GET',
          url: '/content/themes/plust/templates/components/myplust-fail.php',
          dataType: 'html',
          data: {
            lang: lang
          },
          success: function(html){
            $('#myplust-modal .modal-body').html(html);
          }
        });
      }

    });

    return true;
  });


    //---------------------------------------------------------
  // CF7
  var wpcf7Elm = document.querySelector( '.wpcf7' );

  // ---------------------------
  // EVENTO - ERRORI VALIDAZIONE
  if(wpcf7Elm){
    wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
      // Assegno classe 'danger' al rw-responsive
      $('.wpcf7-response-output').addClass('danger');
      // Gestisco gli errori dei singoli campi
      $('.wpcf7 .wpcf7-not-valid-tip').each(function(){
        testo = $(this).text();
        // Se è un checkbox
        if($(this).prev('span').hasClass('wpcf7-form-control')){
          var campo = $(this).closest('div[class^=col]');
          campo.addClass('check');
        }
        // altrimenti è un input/select
        else {
          var campo = $(this).prev('.wpcf7-not-valid');
        }
        // aggiungo tooltip al posto del label
        campo.addClass('da-validare').data('valido', 'no').tooltip({
          placement : 'bottom',
          title : testo
        });
      });
    }, false );
  }


  // RESET VALIDAZIONE AL CLICK
  $('.wpcf7').on('click', '.da-validare', function(){
    resetValidazione($(this));
  });


  // FUNZIONE RESET VALIDAZIONE
  function resetValidazione(elem){
    elem.removeClass('da-validare').removeClass('check').data('valido', '').tooltip('dispose');
  }


  // ---------------------------
  // EVENTO - MAIL SPEDITA CORRETTAMENTE
  if(wpcf7Elm){
    wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
      $('.wpcf7-response-output').addClass('success').removeClass('danger');
    }, false );
  }

  // FINE CF7 -----------------------------------------------
  //---------------------------------------------------------



  // ---------------------------------------------------------- RWMAPPE
  // ----------------------------------------------------------

  if($('body').hasClass('page-template-template-punti-vendita')){
    function mapStart(){
      if (typeof RwMappe != 'undefined') {
        RwMappe.start();
      }
    }
    mapStart();

    function mapSizer(){
      $('#rw-filtered-map').css('max-height', $( window ).height() - $('#mappa').offset().top)
    }
    mapSizer();


    //---------------------------------------------------------
    // ON RESIZE
    $(window).resize(function() {
      mapSizer();
      timouter = setTimeout(mapStart, 500);
      clearTimeout(timouter);
    });
  }



    //---------------------------------------------------------
  // ON RESIZE
  $(window).resize(function() {
    setTimeout(rwOwlNav, 500);
    designer();
    rwMenu();
  });

    //---------------------------------------------------------
  // ON WINDOW LOAD
  $(window).load(function() {
  setTimeout(rwOwlNav, 500);
  designer();
  });


    //---------------------------------------------------------
  // RESPONSIVE
  if ($(window).width() < 576) {

  }
  else if ($(window).width() >= 768 &&  $(window).width() <= 992) {
      // do something for medium screens
  }
  else if ($(window).width() > 992 &&  $(window).width() <= 1200) {
      // do something for big screens
  }
  else  {
      // do something for huge screens
  }


    //---------------------------------------------------------
  // EMAIL TO LOWERCASE
  $('input[type="email"]').keyup(function(){
      $(this).val($(this).val().toLowerCase());
  });

});
